// import React, { useRef } from 'react';
// import ReactToPrint from 'react-to-print';
// import { useTranslation } from 'react-i18next';

// import { ComponentToPrint } from './ComponentToPrint';

// const Example = () => {
//   const componentRef = useRef();
//   const { t } = useTranslation();

//   return (
//     <div>
//       <ReactToPrint
//         trigger={() => <button className="PrintOutClass">{t("Printout")}</button>}
//         content={() => componentRef.current}
//       />
//       <ComponentToPrint ref={componentRef} />
//     </div>
//   );
// };

// export default Example

import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import { ComponentToPrint } from './ComponentToPrint';

const Example = () => {
  const componentRef = useRef();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleDownloadPDF = async () => {
    setLoading(true);

    const input = componentRef.current;

    // Wait for all images to load
    const images = input.querySelectorAll('img');
    await Promise.all(
      Array.from(images).map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) resolve();
            else {
              img.onload = resolve;
              img.onerror = resolve;
            }
          })
      )
    );

    // Use higher scale for better quality (2 is a good start)
    const scale = 1;

    // Get width and height of the element in px
    const elementWidth = input.offsetWidth;
    const elementHeight = input.offsetHeight;

    // Capture the element with html2canvas using scale for high resolution
    const canvas = await html2canvas(input, {
      scale: scale,
      useCORS: true,
      allowTaint: true,
      logging: false,
      width: elementWidth,
      height: elementHeight,
      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight,
    });

    const imgWidth = 210; // A4 width in mm
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfPageHeight = pdf.internal.pageSize.getHeight();

    // Calculate image height based on canvas and pdf width
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Pixels per mm ratio to convert pdf mm to canvas px
    const pxPerMm = canvas.width / imgWidth;

    // Height in pixels of one pdf page slice
    const sliceHeightPx = pdfPageHeight * pxPerMm;

    let heightLeftPx = canvas.height;
    let yOffsetPx = 0;
    let pageNum = 0;

    // Function to get slice from canvas
    const getCanvasSlice = (canvas, startY, height) => {
      const slice = document.createElement('canvas');
      slice.width = canvas.width;
      slice.height = height;
      const ctx = slice.getContext('2d');
      ctx.drawImage(canvas, 0, startY, canvas.width, height, 0, 0, canvas.width, height);
      return slice;
    };

    while (heightLeftPx > 0) {
      const currentSliceHeightPx = heightLeftPx > sliceHeightPx ? sliceHeightPx : heightLeftPx;
      const canvasSlice = getCanvasSlice(canvas, yOffsetPx, currentSliceHeightPx);
      const imgData = canvasSlice.toDataURL('image/png');

      if (pageNum > 0) pdf.addPage();

      const imgSliceHeightMm = (currentSliceHeightPx * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgSliceHeightMm);

      heightLeftPx -= currentSliceHeightPx;
      yOffsetPx += currentSliceHeightPx;
      pageNum++;
    }

    pdf.save('RaceSummary.pdf');
    setLoading(false);
  };

  return (
    <div>
      <button className="PrintOutClass" onClick={handleDownloadPDF} disabled={loading}>
        {loading ? <span className="spinner"></span> : t('Printout')}
      </button>

      <div ref={componentRef}>
        <ComponentToPrint />
      </div>
    </div>
  );
};

export default Example;
